<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;

    // Components
    import { IconBarButton } from '@oat-sa-private/ui-elements';
    import FlyoutMenu from '../flyoutMenu/FlyoutMenu.svelte';
    // Utils
    import { createEventDispatcher } from 'svelte';
    import { getActualKey } from '@oat-sa-private/ui-core';

    export let data;
    export let getBoundingParentRect;

    export let isOpen = false;
    let iconElement;
    let autoFocusMenu = false;

    const dispatch = createEventDispatcher();

    function handleAction(e) {
        dispatch('action', { type: e.detail.key });
        close();
    }

    /**
     * @param {boolean} newOpenValue
     */
    function change(newOpenValue) {
        dispatch('change', newOpenValue);
    }

    function close() {
        dispatch('change', false);
    }

    function open() {
        dispatch('change', true);
    }

    function onFocusOut(event) {
        if (!iconElement.contains(event.relatedTarget)) {
            close();
        }
    }

    function handleKeyDown(event) {
        const keyname = getActualKey(event);

        switch (keyname) {
            case 'escape': {
                event.preventDefault();
                close();
                break;
            }

            case 'enter':
            case 'space':
            case 'down': {
                event.preventDefault();
                autoFocusMenu = true;
                open();
            }
        }
    }
</script>
<style>
    .icon-button-flyout-menu-cell {
        position: relative;
        text-align: right;

        & > :global(.flyout-menu) {
            z-index: var(--layer-1); /* do not cover table header */
            top: 100%;
            right: 0;
            height: max-content;
            width: max-content;
        }
    }
</style>

<div
    class="icon-button-flyout-menu-cell"
    bind:this={iconElement}
    on:focusout={onFocusOut}
    on:keydown={handleKeyDown}
>
    <IconBarButton
        {...data.icon}
        disabled={data.disabled}
        on:click={(event) => {
            event.stopPropagation();
            autoFocusMenu = false;
            change(!isOpen);
        }}
        on:keydown={(event) => {
            handleKeyDown(event);
        }}
    />
    <FlyoutMenu
        bind:open={isOpen}
        autoFocus={autoFocusMenu}
        items={data.items}
        getBoundingParentRect={getBoundingParentRect}
        anchoring={null}
        caller={iconElement}
        on:action={handleAction}
    />
</div>
